var _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _path11, _polygon, _path12, _polygon2, _path13, _path14, _path15, _path16, _path17, _circle, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 568.73047,
    height: 381.17967,
    viewBox: "0 0 568.73047 381.17967",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M883.025,306.463H316.29456a1,1,0,0,1,0-2H883.025a1,1,0,0,1,0,2Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.35484,
    cy: 8.64507,
    rx: 8.45661,
    ry: 8.64507,
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.56859,
    cy: 8.64507,
    rx: 8.45661,
    ry: 8.64507,
    fill: "#e6e6e6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.78234,
    cy: 8.64507,
    rx: 8.45661,
    ry: 8.64507,
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M436.38832,274.6303a.99674.99674,0,0,1-.71484-.30078l-5.70605-5.833a.99954.99954,0,0,1,0-1.39844l5.70605-5.83252a1,1,0,0,1,1.42969,1.39844l-5.022,5.1333,5.022,5.13379a1,1,0,0,1-.71485,1.69922Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M445.9767,274.6303a1,1,0,0,1-.71484-1.69922l5.02148-5.13379-5.02148-5.1333a1,1,0,0,1,1.42969-1.39844l5.70556,5.83252a.99954.99954,0,0,1,0,1.39844l-5.70556,5.833A.99674.99674,0,0,1,445.9767,274.6303Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M832.48653,260.15333h-10.61a2.18934,2.18934,0,0,0-2.19,2.19v10.62a2.18934,2.18934,0,0,0,2.19,2.19h10.61a2.1979,2.1979,0,0,0,2.2-2.19v-10.62A2.1979,2.1979,0,0,0,832.48653,260.15333Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M806.48653,260.15333h-10.61a2.18934,2.18934,0,0,0-2.19,2.19v10.62a2.18934,2.18934,0,0,0,2.19,2.19h10.61a2.1979,2.1979,0,0,0,2.2-2.19v-10.62A2.1979,2.1979,0,0,0,806.48653,260.15333Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M856.98653,260.65333h-10.61a2.18934,2.18934,0,0,0-2.19,2.19v10.62a2.18934,2.18934,0,0,0,2.19,2.19h10.61a2.1979,2.1979,0,0,0,2.2-2.19v-10.62A2.1979,2.1979,0,0,0,856.98653,260.65333Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M642.06484,264.69331h-84.81a2.67,2.67,0,1,0,0,5.34h84.81a2.67,2.67,0,0,0,0-5.34Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M499.86543,524.95276h-84a15.5,15.5,0,1,0,0,31h84a15.5,15.5,0,0,0,0-31Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M499.86536,556.95276h-84a16.5,16.5,0,0,1,0-33h84a16.5,16.5,0,0,1,0,33Zm-84-31a14.5,14.5,0,0,0,0,29h84a14.5,14.5,0,0,0,0-29Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#db9200"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 264.92837,
    y: 103.58919,
    width: 280.48127,
    height: 277.59048,
    rx: 26.74409,
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M731.40283,477.23534a3.97074,3.97074,0,0,1,.17118-5.53569,3.80846,3.80846,0,0,1,.49374-.39089l-3.34656-13.4424,6.22349-4.098,2.59348,18.91007a3.95974,3.95974,0,0,1-.7078,4.78215,3.78946,3.78946,0,0,1-5.35705-.14866Q731.43755,477.27412,731.40283,477.23534Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#ffb6b6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M737.85438,463.98278l-8.16274.758-12.12143-42.63326c-.03512-.11832-3.62439-12.09087-7.25015-13.96388-1.35039-.69737-1.84505-1.1141-1.82561-1.53745.02037-.43731.56868-.659,1.32733-.96586a8.53246,8.53246,0,0,0,2.13938-1.12782c1.65391-1.30745.92685-2.56677-.07952-4.30959-.19538-.33839-.39849-.69017-.59269-1.05806-.57374-1.08642.0676-5.70226,1.90632-13.71884a11.63027,11.63027,0,0,1,10.3196-9.00106h0a11.65621,11.65621,0,0,1,12.67326,10.85874l1.59438,24.68909Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#db9200"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "390.503 356.676 384.825 356.629 382.311 334.216 390.692 334.287 390.503 356.676",
    fill: "#ffb6b6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M687.60989,624.858a2.542,2.542,0,0,0,2.51691,2.56088l11.28951.0942,1.97639-4.00611.72587,4.02654,4.25978.03863-1.07566-14.36125-1.482-.0986-6.045-.4167-1.95024-.1306-.03423,4.06335-9.06889,6.15115A2.53771,2.53771,0,0,0,687.60989,624.858Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "450.286 352.528 444.859 354.196 435.697 333.588 443.708 331.126 450.286 352.528",
    fill: "#ffb6b6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M750.967,625.77846a2.542,2.542,0,0,0,3.17252,1.68167l10.79133-3.318.67491-4.41582,1.90746,3.6196,4.07273-1.249-5.36056-13.36664-1.44266.35336-5.88881,1.42748-1.89869.46419,1.19393,3.88414-6.78907,8.60174A2.53771,2.53771,0,0,0,750.967,625.77846Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M694.3763,427.37368l-10.83593,31.49058-.35782,2.5199c-2.73033,2.59241.69957,3.44646-.58648,4.13012s-2.151,2.6001-.41785,2.94254,1.054,124.98657,8.42445,129.75565,24.38511,10.06421,23.03138,3.08112-.85759-93.22345-.85759-93.22345,36.17868,91.81882,38.65182,91.84768,20.15014-6.61067,19.33238-9.7942-32.92359-82.89542-30.74438-85.96124,3.009-4.39846.85992-4.59924-2.7841.97814-2.90017-1.99587-.487-10.30767-.487-10.30767-1.55665-29.004-12.45806-45.02837l-.9297-9.5211Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M721.44753,367.25032l-14.36984,2.04607-.86711,10.40528-7.091,11.09233s-15.76207,11.09233-4.76908,28.61451l-.71294,9.71822L729.1889,443.434l3.42066-62.33222Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#db9200"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M697.35543,480.82859a3.97075,3.97075,0,0,1,1.73912-5.2582,3.80948,3.80948,0,0,1,.58455-.23426l.61638-13.839,7.13223-2.15792-2.894,18.86642a3.95976,3.95976,0,0,1-2.03917,4.38313,3.78945,3.78945,0,0,1-5.09334-1.66671Q697.37768,480.87564,697.35543,480.82859Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#ffb6b6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M707.311,469.95934l-8.04106-1.59576.50956-44.32c0-.12341-.03451-12.62236-2.97751-15.44956-1.09616-1.05277-1.45181-1.593-1.31272-1.99333.144-.41344.73268-.47,1.54728-.54829a8.53273,8.53273,0,0,0,2.37184-.47251c1.95755-.78285,1.61884-2.197,1.14993-4.15411-.091-.38-.18565-.775-.26716-1.183-.24091-1.20476,1.68722-5.44736,5.73082-12.60946a11.63028,11.63028,0,0,1,12.45407-5.69292h0a11.65621,11.65621,0,0,1,9.06,14.01575l-5.49605,24.12232Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#db9200"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 397.52607,
    cy: 91.66194,
    r: 16.0572,
    fill: "#ffb6b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M734.1,373.08a25.35339,25.35339,0,0,1,4.22,10.32,10.65926,10.65926,0,0,1-5.82,1.68c-.07-.27-.14-.54-.22-.81a23.17164,23.17164,0,0,0-2.64-5.93,13.95855,13.95855,0,0,1-.79,5.86,10.28421,10.28421,0,0,0-3.45-.89,6.268,6.268,0,0,0-2.8.66c-1.01-3.35-1.94-6.43-2.6-8.64-.02,5.54-8.14,10.37-17,9.67-.32-.2,2.89-9.31,2.58-9.52-.71-.47-1.4-.98-2.09-1.48,2.9-4.48,6.05-9.28,5.51-10,.04.89-3.14,5.17-6.6,9.21-1.92-1.41,8.99-24.35,3.6-26.21-.09.81-1.28.81-2.73.64a14.79623,14.79623,0,0,0-1.69-3.79,8.902,8.902,0,0,1-.42,3.51,20.44209,20.44209,0,0,0-4.26.45,13.64978,13.64978,0,0,0-1.07-1.46,8.69234,8.69234,0,0,1-.05,1.69A6.75075,6.75075,0,0,0,693,349c-1.12-.41.79-2.26.09-3.22-1.78-2.4.86-5.9,2.53-8.38a12.73353,12.73353,0,0,1,16.29-3.79c.24-.83,1.47-1.38,3.05-1.75a8.27443,8.27443,0,0,1,2.04-.19c6.8.12,16.24,5.73,16.61,12.52.03.68.08,1.42.13,2.21.48,7.6-.11,14.61005,5.08,20.17005,1.88,2.01,1.9,11.53,1.18,16.43C738.13,381.03,736.8,373.37,734.1,373.08Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M642.08158,626.72844a1.18647,1.18647,0,0,0,1.19007,1.19h165.29a1.19,1.19,0,0,0,0-2.38h-165.29A1.18651,1.18651,0,0,0,642.08158,626.72844Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M562.52316,381.64443H358.1168a4.408,4.408,0,1,1,0-8.81606H562.52316a4.408,4.408,0,0,1,0,8.81606Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M562.52316,475.64443H358.1168a4.408,4.408,0,1,1,0-8.81606H562.52316a4.408,4.408,0,0,1,0,8.81606Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#db9200"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M665.99726,428.67524H358.1168a4.408,4.408,0,1,1,0-8.81606H665.99726a4.408,4.408,0,0,1,0,8.81606Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#db9200"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M566.93076,488.88972a1.00005,1.00005,0,0,1-1-1V454.58308a1,1,0,0,1,2,0v33.30664A1.00005,1.00005,0,0,1,566.93076,488.88972Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M336.24766,360.252a1.00005,1.00005,0,0,1,1-1H370.5543a1,1,0,0,1,0,2H337.24766A1,1,0,0,1,336.24766,360.252Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M353.901,394.88972a1.00005,1.00005,0,0,1-1-1V360.58308a1,1,0,0,1,2,0v33.30664A1.00006,1.00006,0,0,1,353.901,394.88972Z",
    transform: "translate(-315.29456 -259.15243)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.7593a543e4a61af86a6ceba061084554.svg";
export { ForwardRef as ReactComponent };